import {
    gylShowCreateStaff,
    gylShowEditStaff,
    showStaffData,
    showStaffSimpleData,
    queryStaffInfo, 
    saveOrUpdateStaffInfo,
    getAcountList,
    resetPassword,
    editPassword,
    createNewAccount
} from '@api/base/index.js';

// 新增用户时-获取菜单权限列表
export function getCreatePowerList(data) {
    return gylShowCreateStaff(data).then(res => {
        if (res.result === 1 && res.data && res.data.supplyChainPrivilegeTree) {
            const data = res.data.supplyChainPrivilegeTree.left;
            if (data[0] && data[0].kindChildren) {
                return data[0].kindChildren;
            }
            return [];
        }
    })
}
// 修改用户时-获取菜单权限列表
export function getPowerData(data) {
    return gylShowEditStaff(data).then(res => {
        if (res.result === 1 && res.data && res.data.supplyChainPrivilegeTree) {
            const data = res.data.supplyChainPrivilegeTree.left;
            let privilegeTree = [];
            if (data[0] && data[0].kindChildren) {
                privilegeTree = data[0].kindChildren;
            }
            let privilegeSetting = '';
            if (res.data.staffInfo) {
                privilegeSetting = res.data.staffInfo.supplyPrivilegeSetting;
            }
            return {
                privilegeTree,
                privilegeSetting,
                staffInfo: res.data.staffInfo || {}
            };
        }
    })
}
// 获取用户权限数据
export function getStaffData(data) {
    return showStaffData(data).then(res => {
        return res.data || {};
    })
}

// 获取用户基本数据
export function getStaffSimpleData(data) {
    return showStaffSimpleData(data).then(res => {
        return res.data || {};
    })
}

// 获取用户列表
export function getStaffList(data) {
    return queryStaffInfo(data).then(res => {
        if (res.result === 1) {
            return res.data;
        }
    })
}

// 新增, 修改用户
export function addOrUpdateStaffInfo(data){
    return saveOrUpdateStaffInfo(data).then(res => {
        if (res.result === 1) {
            return res.data;
        }
    })
}
// 修改用户时，先获取userRoleList
export function getUserRoleList(data){
    return gylShowEditStaff(data).then(res => {
        if (res.result === 1) {
            if (res.data && res.data.staffInfo) {
                return res.data.staffInfo.userRoleList || []
            }
        }
    })
}


// 新增账户
export function createNewAccountName(data){
    return createNewAccount(data).then(res => {
        if (res.result === 1) {
            return res.data || {};
        }
    })
}

// 获取账号
export function getAcounts(data) {
    return getAcountList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || {};
        }
        return [];
    })
} 
// 修改密码
export function editPwd(data) {
    return editPassword(data).then(res => {
        if (res.result === 1) {
            return true;
        }
    })
}

// 重置密码
export function resetPwd(data) {
    return resetPassword(data).then(res => {
        if (res.result === 1) {
            return true;
        }
    })
}
export function getParentStaffId(list) {
    for(let item of list) {
        if (item.parentId === 0) {
            return item.id;
        }
    }
    return '';
}
export function getExpandedId(tree, checkedKeys) {
    const expanded = [];
    tree.forEach(tr => {
        const children = tr.childrenList || [];
        children.forEach(item => {
            if (checkedKeys.indexOf(item.id) === -1 && expanded.indexOf(item.parentId) === -1) {
                expanded.push(item.parentId);
            }
        })
    })
    return expanded;
}